module.exports = __webpack_public_path__ + "static/media/level04.98704bfa.svg";